import Landing, { SignUp, CreateAccount, EnrollmentPending, RequestPasswordReset} from "./landing"
import Dashboard from './dashboard'
import Redirect from './redirect'

export default {
    Landing, SignUp, CreateAccount, Dashboard, Redirect, EnrollmentPending, RequestPasswordReset
}